import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { logEvent } from "../../helpers/ga";
import local from "../../localization/strings";
import ButtonIcon from "../common/ButtonIcon";
import PageTitle from "../common/PageTitle";
import SiteTreeMenu from "../common/SiteTreeMenu";
import ZoneChartV2 from "./ZoneChartV2";

const ChartLayout = ({ match }) => {
	const [zoneId, setZoneId] = useState("");

	useEffect(() => {
		if (match && match.params && match.params.zoneId) {
			setZoneId(match.params.zoneId);
		} else {
			setZoneId("");
		}
	}, [match]);

	return (
		<>
			<div id="zone-chart-div">
				<Row>
					<Col>
						<PageTitle title={local.TS_ZoneCharts} className="float-left" />
					</Col>
					{zoneId && (
						<Col>
							<ButtonIcon
								outline
								className="float-right mt-3 dark-button mx-1"
								size="sm"
								icon="filter"
								iconAlign="left"
								color="dark"
								onClick={() => {
									logEvent("Zone Charts", "Select Zone Button");
									setZoneId("");
								}}
							>
								{local.TF_ZoneCharts_SelectZone}
							</ButtonIcon>
						</Col>
					)}
				</Row>
				{zoneId ? (
					<ZoneChartV2 match={match} zoneId={zoneId} setZoneId={setZoneId} />
				) : (
					<SiteTreeMenu
						onClick={(data) => {
							setZoneId(data.substring(2));
						}}
						siteMapLevel={2}
						expandToLevel={2}
					/>
				)}
			</div>
		</>
	);
};

export default withRouter(ChartLayout);
